import type { ReactNode } from 'react';
import styles from '../quality-metrics-management.module.scss';

interface StatProps {
  label: ReactNode;
  value: ReactNode;
  hint?: ReactNode;
}

/**
 * A labelled read-only value in one of the detail panel's stat grids.
 *
 * @param props.label - The field name above the value.
 * @param props.value - The value itself, already formatted.
 * @param props.hint - Secondary line under the value, such as a relative time
 *   beside an absolute date. Omitted when there is nothing to add.
 * @returns The stat cell.
 * @example
 * <Stat label={lang.STAT_LAST_INGESTION} value={formatted} hint={relative} />
 */
export function Stat({ label, value, hint }: StatProps) {
  return (
    <div className={styles.stat}>
      <span className={styles.statLabel}>{label}</span>
      <span className={styles.statValue}>{value}</span>
      {hint && <span className={styles.statHint}>{hint}</span>}
    </div>
  );
}
